import { useState } from 'react';
import { useContentEnginePrinters } from '@pm2/content-engine';
import { pm2ConfigStore } from '@pm2/store';
import { generateTextComponentPrintConfig } from '@pm2/text-component';
import { printManager } from '@provider/print';
import { Tooltip } from '@ui/kit';
import { PrinterIcon, DownloadIcon } from '@ui/kit/icons';
import { usePlatformSafari, usePlatformAndroid, loadExportLibrary, downloadURI } from '@utils/common';
import { UniversalContextMenuButton } from '@utils/component-framework';
import { jsxs, Fragment, jsx } from 'react/jsx-runtime';

function PdfExportButton(props) {
  const isSafari = usePlatformSafari();
  const isAndroid = usePlatformAndroid();
  const {
    paperPrinters
  } = useContentEnginePrinters();
  const loginDisabled = pm2ConfigStore.useSelector(state => state.config.settings.loginDisabled);
  const [isPrinting, setPrinting] = useState(false);
  const [progress, setProgress] = useState(undefined);
  const handleClick = async () => {
    setProgress(0);
    try {
      const gExport = await loadExportLibrary();
      const pdfExportConfig = await generateTextComponentPrintConfig(props.node, paperPrinters, "export-service");
      const output = await gExport.convert(pdfExportConfig).on("progress", status => setProgress(status.progress / 100));
      setProgress(undefined);
      downloadURI(output.url);
    } catch (err) {
      setProgress(undefined);
      alert("Download af PDF er midlertidigt ikke tilgængeligt, vi beklager. Prøv igen senere.");
      console.error(err);
    }
  };
  const handlePrint = async () => {
    setPrinting(true);
    await generateTextComponentPrintConfig(props.node, paperPrinters, "browser");
    setPrinting(false);
    printManager.triggerPrintDialog({
      fileName: props.node.meta.caption.title?.value
    });
  };
  const supportsPrintButton = !isSafari && !isAndroid;
  return /*#__PURE__*/jsxs(Fragment, {
    children: [supportsPrintButton && /*#__PURE__*/jsx(Tooltip, {
      mountIn: document.body,
      placement: "left",
      disabled: !loginDisabled,
      body: "Denne funktion kan ikke tilgås i øjeblikket.",
      ariaType: "description",
      children: ref => /*#__PURE__*/jsx(UniversalContextMenuButton, {
        ref: ref,
        as: "button",
        label: "Print",
        onClick: handlePrint,
        disabled: loginDisabled,
        icon: /*#__PURE__*/jsx(PrinterIcon, {}),
        async: isPrinting
      })
    }), /*#__PURE__*/jsx(Tooltip, {
      mountIn: document.body,
      placement: "left",
      disabled: !loginDisabled,
      body: "Denne funktion kan ikke tilgås i øjeblikket.",
      ariaType: "description",
      children: ref => /*#__PURE__*/jsx(UniversalContextMenuButton, {
        ref: ref,
        as: "button",
        label: "Download PDF",
        onClick: handleClick,
        disabled: loginDisabled,
        icon: /*#__PURE__*/jsx(DownloadIcon, {}),
        async: {
          progress
        }
      })
    })]
  });
}

export { PdfExportButton };
//# sourceMappingURL=pdf-export-button.js.map
